import type {SagaIterator} from 'redux-saga';
import {takeEvery, select, call} from 'redux-saga/effects';

import {getQuote} from '../../../reducers/quoteItems/quoteItems';
import {getCartShareId} from '../../../selectors/quoteInfo/quoteInfo';

/**
 * Save cartid in dataLayer.
 */
export function* pushShareIdToDataLayer(): SagaIterator {
    const shareId = yield select(getCartShareId);
    if (shareId)
        yield call([window.dataLayer!, 'push'], {
            CartID: shareId,
        });
}

/**
 * Begin of saga.
 */
export default function* cartAnalyticsSaga(): SagaIterator {
    yield takeEvery(`${getQuote.fulfilled}`, pushShareIdToDataLayer);
}
